import { render, staticRenderFns } from "./CardCouponGoods.vue?vue&type=template&id=cef8b4a2&scoped=true&"
import script from "./CardCouponGoods.vue?vue&type=script&lang=js&"
export * from "./CardCouponGoods.vue?vue&type=script&lang=js&"
import style0 from "./CardCouponGoods.vue?vue&type=style&index=0&id=cef8b4a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cef8b4a2",
  null
  
)

export default component.exports